// https://app.growthbook.io/features/pen-5108_v2
export const EXPERIMENT_FLAG_KEY = 'pen-5108_v2'
